// 财富规划过滤器
// 身份证加密  1234*****1234
const moneyFixed = (id) => {
  let data = '';
  if (id) {
    data = id.replace(/(\d{4})\d{10}(\w{4})/, '$1*****$2');
  }
  return data;
};
/**
 * 保留2位小数
 * @param x不四舍五入
 * @returns {*}
 */
const fmtCustFinanceInfo = (x) => {
  if (x === undefined) {
    return;
  }
  if (x === '-') {
    // eslint-disable-next-line consistent-return
    return '-';
  }
  const f = parseFloat(x);
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(f)) {
    // eslint-disable-next-line consistent-return
    return false;
  }
  const f2 = Math.round(x * 100) / 100;
  let s = f2.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    // eslint-disable-next-line no-const-assign
    rs = s.length;
    // eslint-disable-next-line no-const-assign
    s += '.';
  }
  while (s.length <= rs + 2) {
    // eslint-disable-next-line no-const-assign
    s += '0';
  }
  const parts = s.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // eslint-disable-next-line consistent-return
  return parts.join('.');
};
/**
 * 保留4位小数
 * @param x不四舍五入
 * @returns {*}
 */
const fmtCustFinanceInfoTwo = (x) => {
  if (x === undefined) {
    return;
  }
  if (x === '-') {
    // eslint-disable-next-line consistent-return
    return '-';
  }
  const f = parseFloat(x);
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(f)) {
    // eslint-disable-next-line consistent-return
    return false;
  }
  const f2 = Math.round(x * 100) / 100;
  let s = f2.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    // eslint-disable-next-line no-const-assign
    rs = s.length;
    // eslint-disable-next-line no-const-assign
    s += '.';
  }
  while (s.length <= rs + 4) {
    // eslint-disable-next-line no-const-assign
    s += '0';
  }
  const parts = s.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // eslint-disable-next-line consistent-return
  return parts.join('.');
};
// 去掉千分符
const disMoneyFilter = (x) => {
  if (x.toString().indexOf(',') === -1) {
    return x;
  }
  return x.toString().replace(new RegExp(',', 'g'), '');
};
// 客户男女过滤
const genderFilter = (val) => {
  let data = '';
  if (val) {
    if (val === '1') {
      data = '男';
    } else {
      data = '女';
    }
  }
  return data;
};
const familyRelationship = (x) => {
  let i = '';
  switch (x) {
    case '0':
      i = '本人';
      break;
    case '1':
      i = '配偶';
      break;
    case '2':
      i = '父亲';
      break;
    case '3':
      i = '母亲';
      break;
    case '4':
      i = '儿子';
      break;
    case '5':
      i = '女儿';
      break;
    case '6':
      i = '配偶父亲';
      break;
    case '7':
      i = '配偶母亲';
      break;
    default:
      break;
  }
  return i;
};
// 客户风险等级
const riskLevelFilter = (val) => {
  let data = '';
  // eslint-disable-next-line default-case
  switch (val) {
    case '1':
      data = '保守型';
      break;
    case '2':
      data = '谨慎型';
      break;
    case '3':
      data = '平衡型';
      break;
    case '4':
      data = '进取型';
      break;
    case '5':
      data = '激进型';
      break;
  }
  return data;
};
// 学历
const educationFilter = (val) => {
  let data = '';
  // eslint-disable-next-line default-case
  switch (val) {
    case '1':
      data = '博士';
      break;
    case '2':
      data = '硕士';
      break;
    case '3':
      data = '本科';
      break;
    case '4':
      data = '专科';
      break;
    case '5':
      data = '高中';
      break;
    case '6':
      data = '其他';
      break;
  }
  return data;
};
// 职业
const occupationFilter = (val) => {
  let data = '';
  // eslint-disable-next-line default-case
  switch (val) {
    case '1':
      data = '纯文职人员';
      break;
    case '2':
      data = '部分文职人员';
      break;
    case '3':
      data = '外出工作人员';
      break;
    case '4':
      data = '体力劳动者';
      break;
    case '5':
      data = '重体力劳动者';
      break;
    case '6':
      data = '危险职业';
      break;
    case '7':
      data = '高危职业';
      break;
  }
  return data;
};
// 投资知识
const investmentKnowledgeFilter = (val) => {
  let data = '';
  // eslint-disable-next-line default-case
  switch (val) {
    case '1':
      data = '有专业执照';
      break;
    case '2':
      data = '财经专业毕业';
      break;
    case '3':
      data = '自修有心得';
      break;
    case '4':
      data = '懂一些';
      break;
    case '5':
      data = '一片空白';
      break;
  }
  return data;
};
// 投资经验
const investmentExperienceFilter = (val) => {
  let data = '';
  // eslint-disable-next-line default-case
  switch (val) {
    case '1':
      data = '无';
      break;
    case '2':
      data = '1年以内';
      break;
    case '3':
      data = '1~2年';
      break;
    case '4':
      data = '2~5年';
      break;
    case '5':
      data = '6~10年';
      break;
    case '6':
      data = '10年以上';
      break;
  }
  return data;
};
// 提示信息状态
const tipStatusFilter = (val) => {
  let data = '';
  switch (val) {
    case '2':
      data = '启用';
      break;
    case '1':
      data = '禁用';
      break;
    default:
      data = '未知';
  }
  return data;
};
// 配置管理-字典状态
const dictStatusFilter = (val) => {
  let data = '';
  switch (val) {
    case '2':
      data = '启用';
      break;
    case '1':
      data = '禁用';
      break;
    default:
      data = '未知';
  }
  return data;
};
// 配置管理-字典状态
const emptyCheckFilter = (val) => {
  if (val === '' || val === undefined || val === null) {
    return '-';
  }
  return val;
};
// 财富规划-子女教育第一步费用配置名字过滤
const wpspChildNmaeFilter = (val) => {
  if (val) {
    if (val.length > 6) {
      // eslint-disable-next-line no-param-reassign
      val = `${val.substring(0, 6)}...`;
    }
  }
  return val;
};
// 财富规划-客户基本信息cis过长过滤
const wpspCisFilter = (val) => {
  if (val) {
    if (val.length > 15) {
      // eslint-disable-next-line no-param-reassign
      val = `${val.substring(0, 15)}...`;
    }
  }
  return val;
};
// 保留两位小数，增加千分符
const addMoneyFilter = (x) => {
  if (x === undefined) {
    return;
  }
  if (`${x}`.indexOf(',') !== -1) {
    // eslint-disable-next-line consistent-return
    return x;
  }
  // 将入参x转换成float类型的小数。假设入参为100000
  const f = parseFloat(x);
  // 如果为空则返回默认值
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(f)) {
    // eslint-disable-next-line consistent-return
    return '0.00';
  }
  // 将入参四舍五入并保留两位小数
  const f2 = Math.round(x * 100) / 100;
  // 将四舍五入后的入参转为字符类型
  let s = f2.toString();
  // 筛选该入参中是否有小数点 有则返回小数点的位置，没有则返回-1
  let rs = s.indexOf('.');
  // 小于0，代表该入参没有小数点，所以该入参为整数
  if (rs < 0) {
    // 将入参的长度赋值给rs
    rs = s.length;
    // 在入参后连上小数点
    s += '.';
  }
  // 循环在入参后补 100000.00
  while (s.length <= rs + 2) {
    s += '0';
  }
  // 将入参根据小数点分割成两部分。分割后为100000和00。
  const parts = s.toString().split('.');
  // parts[0]为取左边整数位。是正则表达式，如果整数位大于3，就在后边添加逗号(千分符)
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // 重新拼起来 100,000.00
  // eslint-disable-next-line consistent-return
  return parts.join('.');
};
export {
  // eslint-disable-next-line max-len
  moneyFixed,
  fmtCustFinanceInfo,
  fmtCustFinanceInfoTwo,
  genderFilter,
  riskLevelFilter,
  tipStatusFilter,
  dictStatusFilter,
  emptyCheckFilter,
  wpspChildNmaeFilter,
  addMoneyFilter,
  disMoneyFilter,
  familyRelationship,
  wpspCisFilter,
  educationFilter,
  occupationFilter,
  investmentKnowledgeFilter,
  investmentExperienceFilter,
};
